import type {
  GoToPage,
  GoToNextPage,
  GoToPrevPage,
} from '@tmsw/powerups.config.page.provider';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { CTAButtonList } from '../../components/CTAButtonList';
import { HeaderH1 } from '../../components/promo/HeaderH1';
import { GameInstructionsContent } from '../../components/GameInstructionsContent';
import './GameInstructions.css';
import { useStore } from '@tmsw/powerups.store';
import { useEffect } from 'react';

export type GameInstructionsProps = {
  goToPage: GoToPage;
  goToPrevPage: GoToPrevPage;
  goToNextPage: GoToNextPage;
};

export const GameInstructions = ({
  goToPage,
  goToPrevPage,
  goToNextPage,
}: GameInstructionsProps) => {
  // defs
  const parentNode = 'GAME_INSTRUCTIONS';
  const gameCharacter = useStore((state) => state.gameCharacter);

  // hooks
  const { __t } = useTranslation(parentNode);
  const selectedPokemonAnnouncer = `${__t(
    'selected',
    'GAME_PLAY'
  )}  ${gameCharacter}`;
  // const setPageTitle = useStore((state) => state.setPageTitle);
  // const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  // const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  // const inPortrait = useStore((state) => state.inPortrait);

  // useEffect(() => {
  //   setPageTitle(__t('pageTitle'));
  // }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  return (
    <section
      className="game-instructions-section"
      style={{
        backgroundImage: `url(${__t('backgrounds.vignette', 'GENERAL')})`,
      }}
    >
      <div
        role="status"
        className="sr-only"
        aria-live="assertive"
        aria-atomic={true}
        tabIndex={-1}
      >
        {selectedPokemonAnnouncer}
      </div>
      <HeaderH1 textValue={__t('howToPlay', 'SETTINGS_PANEL')} />
      <GameInstructionsContent />
      <CTAButtonList config={__t('ctaButtonList')} />
    </section>
  );
};
